// extracted by mini-css-extract-plugin
module.exports = {"Row":"TestError_Row__IrgkW","Header":"TestError_Header__e8pzo","Icon":"TestError_Icon__oyhh8","Error":"TestError_Error__TMruw"};